import React, { useEffect, useState } from "react";
import IREMaster from "./IRE/IREMaster";
import { GiHamburgerMenu } from "react-icons/gi";
import { BsMotherboard } from "react-icons/bs";

const pages = [
  "Pre Departure Detention (PDD)",
  "Intensive Release Empty (IRE)",
  "Crack",
  "Point Wise Interchange",
  "Long Haul",
  "NKJ Yard Ex",
  "STA Yard",
];
const OthersSidebar = ({ setActivePage, activePage }) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    // Handler to update isDesktop based on window width
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    // Set initial value
    handleResize();
    // Add event listener for resize
    window.addEventListener("resize", handleResize);
    // Cleanup: Remove event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty dependency array since we don't depend on props/state

  return (
    <div className="border" style={{ height: isDesktop ? "100vh" : "auto" }}>
      <h6 className="bg-dark  text-white p-1">
        <BsMotherboard /> Other Reports
      </h6>
      <div className="row m-3">
        {pages.map((page, key) => {
          return (
            <button
              key={key}
              className={`btn btn-sm btn-outline-dark m-1 Subject ${
                activePage === page && "active"
              } `}
              onClick={() => {
                setActivePage(page);
              }}
            >
              {page}{" "}
            </button>
          );
        })}

        <button className=" btn btn-sm btn-outline-dark  Subject mt-2">
          {" "}
          <a
            className=""
            href="https://lookerstudio.google.com/u/0/reporting/5f085f81-8e72-47ec-9ad8-fbb92f0ccce7"
            target="_blank"
            rel="noopener noreferrer"
          >
            BLOCK DATA looker Studio
          </a>
        </button>

        <button className=" btn btn-sm btn-outline-dark Subject mt-2 ">
          {" "}
          <a
            className=""
            href="https://lookerstudio.google.com/u/0/reporting/15a112a7-7436-4eca-b7a4-e4868dea961a/page/E06vD"
            target="_blank"
            rel="noopener noreferrer"
          >
            FOOD GRAIN looker Studio
          </a>
        </button>

        <button className=" btn btn-sm btn-outline-dark mt-2 Subject">
          {" "}
          <a
            className=""
            href="https://lookerstudio.google.com/u/0/reporting/c653d229-a863-44ac-9c75-31904881519e/page/p_k52vp9kwvd"
            target="_blank"
            rel="noopener noreferrer"
          >
            CMS Crew position
          </a>
        </button>

        <button className=" btn btn-sm btn-outline-dark  Subject mt-2">
          {" "}
          <a
            className=""
            href="https://lookerstudio.google.com/u/0/reporting/fd8139f1-ea0f-4ec1-b040-fd1476c2e5d3/page/eN65D"
            target="_blank"
            rel="noopener noreferrer"
          >
            Rake Loading Terminal Detention
          </a>
        </button>

        <button className=" btn btn-sm btn-outline-dark  Subject mt-2">
          {" "}
          <a
            className=""
            href="https://lookerstudio.google.com/u/0/reporting/eec5b120-da34-4e38-b147-c0c37b4749c9/page/vMx4D"
            target="_blank"
            rel="noopener noreferrer"
          >
            Rake Unloading Terminal Detention
          </a>
        </button>
      </div>
    </div>
  );
};
export default OthersSidebar;
